// Knights Three Data - Group Three (Specialized & Unique Knights)

// Sir Kay the Seneschal's workout programs
const kayPrograms = [
    {
        id: 'royal-steward-training',
        name: 'Royal Steward Training',
        description: 'Administrative excellence combined with knightly combat prowess',
        pattern: '|&${+>',
        reps: 13,
        sets: 5,
        focus: 'Administrative Power'
    },
    {
        id: 'seneschal-conditioning',
        name: 'Seneschal Conditioning',
        description: 'Organizational strength for managing kingdoms and courts',
        pattern: '{|&$>+',
        reps: 15,
        sets: 4,
        focus: 'Kingdom Management'
    },
    {
        id: 'griffin-feather-protocol',
        name: 'Griffin Feather Protocol',
        description: 'Majestic training that embodies the pride of the griffin crest',
        pattern: '+>{|&$',
        reps: 17,
        sets: 4,
        focus: 'Majestic Pride'
    },
    {
        id: 'foster-brother-strength',
        name: 'Foster Brother Strength',
        description: 'Familial bond conditioning for Arthur\'s childhood companion',
        pattern: '$&+{|>',
        reps: 12,
        sets: 6,
        focus: 'Brotherly Bond'
    },
    {
        id: 'keys-and-crown-training',
        name: 'Keys and Crown Training',
        description: 'Symbolic power training for the keeper of royal authority',
        pattern: '||{{>>',
        reps: 19,
        sets: 3,
        focus: 'Royal Authority'
    },
    {
        id: 'camelot-stewardship-mastery',
        name: 'Camelot Stewardship Mastery',
        description: 'The complete training for managing the greatest kingdom in legend',
        pattern: '|&${+>!!',
        reps: 21,
        sets: 3,
        focus: 'Kingdom Mastery'
    }
];

// Sir Pelleas the Gentle's workout programs
const pelleasPrograms = [
    {
        id: 'gentle-knight-training',
        name: 'Gentle Knight Training',
        description: 'Refined conditioning that embodies perfect chivalric ideals',
        pattern: '}:&*$+',
        reps: 11,
        sets: 7,
        focus: 'Chivalric Ideals'
    },
    {
        id: 'silver-star-conditioning',
        name: 'Silver Star Conditioning',
        description: 'Celestial strength training inspired by the stars above',
        pattern: '*}:&$+',
        reps: 14,
        sets: 5,
        focus: 'Celestial Power'
    },
    {
        id: 'peacock-plume-protocol',
        name: 'Peacock Plume Protocol',
        description: 'Graceful power that displays noble beauty in combat',
        pattern: '&+*}:$',
        reps: 16,
        sets: 4,
        focus: 'Noble Beauty'
    },
    {
        id: 'melancholic-strength',
        name: 'Melancholic Strength',
        description: 'Sorrowful conditioning that channels deep emotion into power',
        pattern: '$:}&*+',
        reps: 13,
        sets: 5,
        focus: 'Emotional Depth'
    },
    {
        id: 'gentle-grey-training',
        name: 'Gentle Grey Training',
        description: 'Destrier conditioning for the most noble and beautiful mounts',
        pattern: '::}}$$',
        reps: 18,
        sets: 4,
        focus: 'Noble Mounts'
    },
    {
        id: 'idealistic-mastery-conditioning',
        name: 'Idealistic Mastery Conditioning',
        description: 'The ultimate training for the knight who embodies perfect gentleness',
        pattern: '}:&*$+!!',
        reps: 22,
        sets: 3,
        focus: 'Perfect Gentleness'
    }
];

// Sir Marrok the Werewolf Knight's workout programs
const marrokPrograms = [
    {
        id: 'werewolf-knight-training',
        name: 'Werewolf Knight Training',
        description: 'Dual nature conditioning for human knight and wolf warrior',
        pattern: '-}:x&*',
        reps: 16,
        sets: 4,
        focus: 'Dual Nature'
    },
    {
        id: 'lupine-transformation-conditioning',
        name: 'Lupine Transformation Conditioning',
        description: 'Metamorphic strength training that bridges human and wolf forms',
        pattern: 'x-}:&*',
        reps: 19,
        sets: 3,
        focus: 'Transformation Power'
    },
    {
        id: 'yellow-eyes-protocol',
        name: 'Yellow Eyes Protocol',
        description: 'Predatory conditioning that sees through the darkness',
        pattern: '*&:}-x',
        reps: 14,
        sets: 5,
        focus: 'Predatory Sight'
    },
    {
        id: 'moon-cycle-strength',
        name: 'Moon Cycle Strength',
        description: 'Lunar-powered training that waxes and wanes with natural rhythms',
        pattern: '}*x-:&',
        reps: 17,
        sets: 4,
        focus: 'Lunar Power'
    },
    {
        id: 'pack-leader-training',
        name: 'Pack Leader Training',
        description: 'Alpha conditioning for leading both human knights and wolf packs',
        pattern: '--::}}',
        reps: 21,
        sets: 3,
        focus: 'Alpha Leadership'
    },
    {
        id: 'cursed-nobility-mastery',
        name: 'Cursed Nobility Mastery',
        description: 'The complete training for a knight who straddles two worlds',
        pattern: '-}:x&*!!',
        reps: 24,
        sets: 3,
        focus: 'Cursed Excellence'
    }
];

// Sir Brunor le Noir (The Black Knight)'s workout programs
const brunorPrograms = [
    {
        id: 'black-knight-training',
        name: 'Black Knight Training',
        description: 'Dark armor conditioning that absorbs light and hope',
        pattern: ')(*&x>',
        reps: 18,
        sets: 4,
        focus: 'Dark Presence'
    },
    {
        id: 'void-armor-conditioning',
        name: 'Void Armor Conditioning',
        description: 'Mysterious strength that seems to draw power from darkness itself',
        pattern: 'x)(*&>',
        reps: 20,
        sets: 3,
        focus: 'Void Power'
    },
    {
        id: 'faceless-warrior-protocol',
        name: 'Faceless Warrior Protocol',
        description: 'Anonymous conditioning for the knight who reveals nothing',
        pattern: '&>x)(*',
        reps: 15,
        sets: 5,
        focus: 'Anonymous Strength'
    },
    {
        id: 'black-destrier-strength',
        name: 'Black Destrier Strength',
        description: 'Shadow mount training for horses as dark as their master',
        pattern: '*)(&>x',
        reps: 16,
        sets: 4,
        focus: 'Shadow Mounts'
    },
    {
        id: 'intimidation-training',
        name: 'Intimidation Training',
        description: 'Psychological warfare through overwhelming dark magnificence',
        pattern: '))((>>',
        reps: 22,
        sets: 3,
        focus: 'Dark Magnificence'
    },
    {
        id: 'noir-mastery-conditioning',
        name: 'Noir Mastery Conditioning',
        description: 'The ultimate training for the most mysterious of all knights',
        pattern: ')(*&x>!!',
        reps: 25,
        sets: 3,
        focus: 'Ultimate Mystery'
    }
];

// Sir Dinadan the Humorous's workout programs
const dinadanPrograms = [
    {
        id: 'humorous-knight-training',
        name: 'Humorous Knight Training',
        description: 'Joyful conditioning that brings laughter to the Round Table',
        pattern: '[]=*&+',
        reps: 12,
        sets: 6,
        focus: 'Joyful Power'
    },
    {
        id: 'laughing-warrior-conditioning',
        name: 'Laughing Warrior Conditioning',
        description: 'Cheerful strength training that proves joy enhances combat ability',
        pattern: '*[]=&+',
        reps: 14,
        sets: 5,
        focus: 'Cheerful Strength'
    },
    {
        id: 'colorful-feather-protocol',
        name: 'Colorful Feather Protocol',
        description: 'Vibrant training that displays the beauty of knightly spirit',
        pattern: '&+*[]=',
        reps: 13,
        sets: 5,
        focus: 'Vibrant Spirit'
    },
    {
        id: 'bell-jingling-strength',
        name: 'Bell Jingling Strength',
        description: 'Musical conditioning that announces joy wherever it goes',
        pattern: '=[]*&+',
        reps: 15,
        sets: 4,
        focus: 'Musical Joy'
    },
    {
        id: 'mirth-and-valor-training',
        name: 'Mirth and Valor Training',
        description: 'Balanced conditioning proving courage and humor go hand in hand',
        pattern: '[[]]>>',
        reps: 17,
        sets: 4,
        focus: 'Joyous Courage'
    },
    {
        id: 'round-table-comedian-mastery',
        name: 'Round Table Comedian Mastery',
        description: 'The complete training for the knight who brought laughter to legend',
        pattern: '[]=*&+!!',
        reps: 19,
        sets: 3,
        focus: 'Legendary Humor'
    }
];

// Sir Pellimore the Questing Beast Hunter's workout programs
const pellimorePrograms = [
    {
        id: 'questing-beast-hunter-training',
        name: 'Questing Beast Hunter Training',
        description: 'Relentless conditioning for the eternal pursuit of the impossible',
        pattern: '<|}&*>',
        reps: 20,
        sets: 4,
        focus: 'Eternal Pursuit'
    },
    {
        id: 'beast-tracker-conditioning',
        name: 'Beast Tracker Conditioning',
        description: 'Hunting strength for tracking the most elusive of all creatures',
        pattern: '>}<|&*',
        reps: 22,
        sets: 3,
        focus: 'Master Hunter'
    },
    {
        id: 'white-hart-protocol',
        name: 'White Hart Protocol',
        description: 'Sacred quarry training for pursuing divine and mystical beasts',
        pattern: '*&|}<>',
        reps: 18,
        sets: 4,
        focus: 'Sacred Hunt'
    },
    {
        id: 'weathered-warrior-strength',
        name: 'Weathered Warrior Strength',
        description: 'Endurance conditioning scarred by years of relentless questing',
        pattern: '|>*}&<',
        reps: 24,
        sets: 3,
        focus: 'Quest Endurance'
    },
    {
        id: 'obsession-training',
        name: 'Obsession Training',
        description: 'Focused conditioning that channels single-minded pursuit into power',
        pattern: '<<||}}',
        reps: 26,
        sets: 3,
        focus: 'Obsessive Focus'
    },
    {
        id: 'legendary-hunter-mastery',
        name: 'Legendary Hunter Mastery',
        description: 'The ultimate training for the greatest hunter in all of legend',
        pattern: '<|}&*>!!',
        reps: 28,
        sets: 3,
        focus: 'Ultimate Hunter'
    }
];

// Main Knights Three trainers data object - Group Three
const knightsThreeTrainersData = {
    'sir-kay-the-seneschal': {
        id: 'sir-kay-the-seneschal',
        name: 'Sir Kay the Seneschal',
        title: 'Arthur\'s Foster Brother',
        specialization: 'Administrative Combat & Royal Stewardship',
        image: '/assets/images/Sir-Kay-the-Seneschal.jpg',
        experience: '40+ years',
        category: 'knights-three',
        color: '#FFD700',
        secondaryColor: '#DC143C',
        intro: `Arthur's foster brother and chief administrator of Camelot, Kay combines knightly prowess with administrative excellence. His gold and red checkerboard surcoat displays his high office, while his griffin-crested helm shows his pride. His training proves that the greatest battles are often won through superior organization and preparation.`,
        programs: kayPrograms
    },
    'sir-pelleas-the-gentle': {
        id: 'sir-pelleas-the-gentle',
        name: 'Sir Pelleas the Gentle',
        title: 'The Idealistic Knight',
        specialization: 'Chivalric Excellence & Noble Refinement',
        image: '/assets/images/Sir-Pelleas-the-Gentle.jpg',
        experience: '32+ years',
        category: 'knights-three',
        color: '#87CEEB',
        secondaryColor: '#C0C0C0',
        intro: `The most idealistic knight of the Round Table, devoted utterly to chivalric perfection. His pale blue surcoat decorated with silver stars reflects his ethereal nobility, while his peacock plumes display his refined nature. His training emphasizes that true strength comes from maintaining noble ideals even in the face of harsh reality.`,
        programs: pelleasPrograms
    },
    'sir-marrok-the-werewolf-knight': {
        id: 'sir-marrok-the-werewolf-knight',
        name: 'Sir Marrok the Werewolf',
        title: 'The Cursed Knight',
        specialization: 'Transformation Combat & Lupine Warfare',
        image: '/assets/images/Sir-Marrok-the-Werewolf-Knight.jpg',
        experience: '25+ years',
        category: 'knights-three',
        color: '#8B4513',
        secondaryColor: '#FFD700',
        intro: `Cursed to transform into a wolf by day, Marrok straddles two worlds with wild grace. His fur-trimmed mail and wolf-headed shield reflect his dual nature, while his yellow eyes see truths hidden from others. His training teaches students to embrace their wild side and find strength in their most primal instincts.`,
        programs: marrokPrograms
    },
    'sir-brunor-le-noir-the-black-knight': {
        id: 'sir-brunor-le-noir-the-black-knight',
        name: 'Sir Brunor le Noir',
        title: 'The Black Knight',
        specialization: 'Dark Presence & Anonymous Warfare',
        image: '/assets/images/Sir-Brunor-le-Noir-The-Black-Knight.jpg',
        experience: '35+ years',
        category: 'knights-three',
        color: '#000000',
        secondaryColor: '#2F2F2F',
        intro: `The most mysterious knight of all, who never reveals his face or speaks above a whisper. His pure black armor seems to absorb light itself, and his presence fills others with both awe and unease. His training shows that sometimes the greatest power comes from what remains hidden and unknown.`,
        programs: brunorPrograms
    },
    'sir-dinadan-the-humorous': {
        id: 'sir-dinadan-the-humorous',
        name: 'Sir Dinadan the Humorous',
        title: 'The Laughing Knight',
        specialization: 'Joyful Combat & Morale Warfare',
        image: '/assets/images/Sir-Dinadan-the-Humorous.jpg',
        experience: '30+ years',
        category: 'knights-three',
        color: '#FFFF00',
        secondaryColor: '#32CD32',
        intro: `The one knight who brought laughter and joy to the often serious Round Table. His bright yellow and green striped surcoat and colorful feathered helm reflect his cheerful nature. His training proves that joy and humor are not weaknesses but sources of incredible strength and resilience.`,
        programs: dinadanPrograms
    },
    'sir-pellimore-the-questing-beast-hunter': {
        id: 'sir-pellimore-the-questing-beast-hunter',
        name: 'Sir Pellimore',
        title: 'The Questing Beast Hunter',
        specialization: 'Beast Hunting & Obsessive Pursuit',
        image: '/assets/images/Sir-Pellimore-the-Questing-Beast-Hunter.jpg',
        experience: '50+ years',
        category: 'knights-three',
        color: '#228B22',
        secondaryColor: '#FFFFFF',
        intro: `The eternal hunter, forever pursuing the legendary Questing Beast across endless wilderness. His forest green surcoat bears the white hart, symbol of his sacred hunt. His training teaches the power of single-minded focus and shows that some quests are more important than their completion.`,
        programs: pellimorePrograms
    }
};

// Export the data
export default knightsThreeTrainersData;